// frontend/src/services/socket.service.js
import { io } from 'socket.io-client';
import { ref } from 'vue';

let socket = null;
const connected = ref(false);

function connect() {
  if (socket) return socket;

  // En production, nginx proxy /socket.io/ vers le backend port 3000
  // En dev, on se connecte directement au backend
  const url = process.env.VUE_APP_SOCKET_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : undefined);

  socket = io(url, {
    // Le serveur refuse toute connexion sans jeton d'accès (realtime.service.js, 01/10/2026).
    // Une FONCTION, relue à chaque (re)connexion : le jeton courant, pas celui du premier appel.
    auth: cb => cb({ token: localStorage.getItem('auth_token') || '' }),
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: Infinity
  });

  socket.on('connect', () => {
    connected.value = true;
    console.log('[WS] Connecté au serveur');
  });

  socket.on('disconnect', (raison) => {
    connected.value = false;
    console.log('[WS] Déconnecté du serveur', raison);
    // Coupure VOULUE par le serveur (disconnectSockets : rôle d'un membre changé, mot de passe
    // changé, admin retiré…) : socket.io ne se reconnecte pas seul dans ce cas. On rouvre 3 s
    // plus tard avec le jeton courant ; si le serveur refuse, connect_error tranche
    // (relevé de l'agent de l'app mobile, 02/10/2026 — même règle que l'app).
    if (raison === 'io server disconnect') {
      const s = socket;
      setTimeout(() => { if (s && s === socket && !s.connected) s.connect(); }, 3000);
    }
  });

  // Refus du serveur. Les refus DÉFINITIFS (session périmée, compte retiré, jeton refusé)
  // renvoient à la connexion : retenter en boucle ne changerait rien. Les autres laissent
  // `connected` à false — la bannière « connexion temps réel perdue » le dit.
  socket.on('connect_error', (err) => {
    connected.value = false;
    const raison = err && err.message;
    console.warn('[WS] Connexion refusée :', raison);
    const definitif = ['session_perimee', 'session_revoquee', 'compte_en_suppression', 'compte_revoque', 'jeton_expire', 'jeton_invalide', 'jeton_non_acces'];
    if (definitif.includes(raison) && localStorage.getItem('auth_token')
        && !window.location.pathname.startsWith('/login')) {
      disconnect();
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
  });

  return socket;
}

function getSocket() {
  if (!socket) return connect();
  return socket;
}

// Même compte, jeton renouvelé (changement de mot de passe) : on rouvre la MÊME connexion — les
// écrans gardent leurs abonnements (socket.on) — avec le jeton courant, relu par `auth`.
function reconnecter() {
  if (!socket) return connect();
  socket.disconnect();
  socket.connect();
  return socket;
}

function disconnect() {
  if (socket) {
    socket.disconnect();
    socket = null;
    connected.value = false;
  }
}

export default {
  connect,
  getSocket,
  disconnect,
  reconnecter,
  connected
};
